import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import Classes from './index.module.css';
import axios from 'axios';
import localSitemapData from './sitemapData.json'; // Import the JSON data locally with a different name

const SiteMap = (props) => {
  const [sitemapData, setSitemapData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Check if the environment variable exists
        if (process.env.REACT_APP_CHOOSELOWRATES_SITEMAP_JSON) {
          try {
            // Try to fetch data from the API
            const response = await axios.get(process.env.REACT_APP_CHOOSELOWRATES_SITEMAP_JSON);
            
            if (response.status === 200) {
              // API call successful, use the response data
              setSitemapData(response.data);
            } else {
              // API call returned non-200 status, fallback to local data
              console.warn('API returned non-200 status, using local data');
              setSitemapData(localSitemapData);
            }
          } catch (error) {
            // API call failed (network error, etc), fallback to local data
            console.error('Error fetching sitemap data from API:', error);
            setSitemapData(localSitemapData);
          }
        } else {
          // No environment variable, use local data
          console.log('Using local sitemap data');
          setSitemapData(localSitemapData);
        }
      } catch (error) {
        // Catch any other errors and fallback to local data
        console.error('Unexpected error in sitemap component:', error);
        setSitemapData(localSitemapData);
      } finally {
        // Set loading to false regardless of outcome
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    // Render loading indicator while data is being fetched
    return <div>Loading...</div>;
  }

  if (!sitemapData) {
    // This should rarely happen, but just in case both API and local data fail
    return <div>Error loading sitemap data.</div>;
  }

  return (
    <Container fluid className={Classes.pageContainer}>
      <Row>
        {sitemapData.sections.map((section, index) => (
          <Col key={index} sm={{ span: 4, offset: index > 0 ? 0 : 0 }}>
            <div className={Classes.site_map_section}>
              <ul>
                <li className={Classes.content_head}>
                  {/* Check if there's a link for the title, if not, render it as plain text */}
                  {section.link ? (
                    <Link to={section.link}>{section.title}</Link>
                  ) : (
                    <span>{section.title}</span>
                  )}
                </li>
                {section.links && section.links.map((link, idx) => (
                  <li key={idx}>
                    {link.external ? (
                      <a href={link.link} target="_blank" rel="noopener noreferrer">{link.title}</a>
                    ) : (
                      <Link to={link.link}>{link.title}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default SiteMap;